import React from "react";
import { useParams } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import EditForms from "../components/clients/edit-forms";
import ClientEditLockManager from "../components/clients/ClientEditLockManager";

const queryClient = new QueryClient();

interface EditClientParams {
  id: string | number;
}

const EditClient: React.FC = () => {
  let { id } = useParams();

  // Force component to remount when id changes
  // Key prop ensures ClientEditLockManager unmounts when navigating to different client
  return (
    <div>
      <div className="hidden flex-col md:flex">
        <Header />
        <QueryClientProvider client={queryClient}>
          <div className="container mx-auto px-4 py-6" key={`edit-${id}`}>
            <ClientEditLockManager key={`lock-${id}`} />
            <EditForms />
          </div>
        </QueryClientProvider>
        <Footer />
      </div>
    </div>
  );
};

export default EditClient;
